module.exports = __webpack_public_path__ + "img/SkolOriginal_Drept-01.5524e887.png";